module.exports = __webpack_public_path__ + "static/img/life_logo.d31cda1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/lifePay/life_logo.png
// module id = Y3b/
// module chunks = 1